import React from 'react';
import Seo from './Seo';

const Electromechanical = () => {
  const title = 'Electromechanical Systems Supply & Installation — Dubai | Fusion Tech';
  const description = 'Fusion Tech supplies and installs electromechanical systems in Dubai — SCADA, PLCs, control panels, instrumentation and spare parts. Fast delivery & certified installers.';
  const url = 'https://fusiontechuae.com/electromechanical-systems-dubai/';

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Electromechanical Systems Supply and Installation",
    "provider": {
      "@type": "LocalBusiness",
      "name": "Fusion Tech General Trading FZCO",
      "telephone": "+971522340058",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "IFZA Business Park Building A1",
        "addressLocality": "Dubai Silicon Oasis",
        "addressRegion": "Dubai",
        "addressCountry": "AE"
      }
    },
    "areaServed": "Dubai",
    "description": description
  };

  return (
    <div>
      <Seo
        title={title}
        description={description}
        url={url}
        keywords="Electromechanical Systems Supply and Installation in Dubai, Industrial Automation Dubai UAE, Control Panels from Dubai, Machine Supply from Dubai, Electrical Spare Parts in Dubai UAE"
        jsonLd={jsonLd}
      />
      <main className="container mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold mb-4">Electromechanical Systems Supply and Installation in Dubai</h1>
        <p className="text-gray-700 mb-4">Fusion Tech delivers turnkey electromechanical systems across Dubai and the UAE. From system design and supply to installation, testing and commissioning of PLCs, control panels and instrumentation, we ensure reliable, code-compliant solutions for industrial projects.</p>
        <p className="text-gray-700 mb-6">
          We also support Industrial Automation Dubai UAE projects with Electrical Spare Parts in Dubai UAE and Automation Spare Parts Dubai UAE,
          including PLC, RTU, DCS from Dubai, Control Panels from Dubai, and Machine Supply from Dubai.
        </p>

        <section className="mb-6">
          <h2 className="text-xl font-semibold">What we offer</h2>
          <ul className="list-disc ml-6 mt-2 text-gray-700">
            <li>System design and engineering (PLC, SCADA, control panels)</li>
            <li>Supply of OEM parts and spare components</li>
            <li>Installation, wiring and commissioning services</li>
            <li>Testing, calibration and factory acceptance testing (FAT)</li>
            <li>On-site support, maintenance and spare parts supply</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold">Why choose Fusion Tech</h2>
          <p className="text-gray-700">We combine certified engineers, trusted suppliers and local UAE experience to deliver projects on time and on budget. Our approach focuses on safety, uptime and long-term maintainability.</p>
          <ul className="list-disc ml-6 mt-2 text-gray-700">
            <li>Local presence in Dubai with fast response times</li>
            <li>Certified technicians and project managers</li>
            <li>Comprehensive warranty and spare-part sourcing</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold">Case study — Factory automation retrofit</h2>
          <p className="text-gray-700">A recent retrofit project replaced legacy PLCs and integrated new SCADA panels to provide centralized monitoring. The project reduced downtime by 23% and lowered energy consumption through better control strategies.</p>
        </section>

        <section className="mt-8">
          <a className="inline-block bg-fusion-blue text-white px-5 py-3 rounded" href="/contactus">Contact us for a quote</a>
          <a className="inline-block ml-3 text-fusion-blue font-medium" href="/scada-solutions-dubai">SCADA Solutions in Dubai, UAE →</a>
        </section>
      </main>
    </div>
  );
};

export default Electromechanical;
